/**
 * Agree to Terms & Conditions component module.
 * @module /investor/pages/AgreeTerms
 *
 */

import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import debug from 'debug';
import styled from 'styled-components/macro';
import {
  Button,
  Checkbox,
  Column,
  DescriptiveText,
  Image,
  Page, Row,
  Tile,
} from '../../shared';
import {_openModal, _removeModal} from '../../shared/store';
import axiosInstance from '../../shared/utils/axios';
import history from '../../history';
import {withRouter} from 'react-router-dom';

const log = debug('circleblack:investor:AgreeToTerms');

const _Brand = styled(Column)`
  background-color: ${props => props.theme.tileBackgroundColor};
  ${props => props.theme.neumorphic
    ? `box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.4),
                   1px 1px 0 0 rgba(0, 0, 0, 0.5),
                   -1px -1px 0 0 rgba(255, 255, 255, 0.2)` : ''};
`;
/**
 * Agree to Terms & Conditions component
 * @name AgreeToTerms
 */

const AgreeToTerms = props => {
  const {product, openModal, session} = props;
  const {brand} = product;
  const [processing, setProcessing] = useState();
  const isLogoSpaceShared = !!brand.backgroundImage;
  const [accepted, setAccepted] = useState(false);

  if (!session.token && !localStorage.token) {
    log('redirecting to /');
    history.push('/');
  }
  log('rendering');

  return <Page backgroundImage={brand.backgroundImage} minHeight='100vh'>
    <Row alignItems='middle' alignSubRow='center' justifySubRow='center' width='100%' wrap={true}>
      <Row alignItems='middle'
           height='fit-content'
           justifySubRow='center'
           wrap={false}>
        <_Brand height='fit-content'
                width='fit-content'
                justifySubColumn='middle'
                alignItems='center'
                backgroundColor={props?.theme?.dark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}
                backDropFilter='10px'
                borderRadius='12px'>
          {!!brand.logo && <Image maxHeight='120px' maxWidth='270px' margin='20px' src={brand.logo}/>}
        </_Brand>
      </Row>
      <Row alignItems='middle' justifySubRow='center' height='fit-content' width='fit-content' wrap={false}>
        <Tile title={'TERMS AND CONDITIONS'}
              maxWidth={isLogoSpaceShared ? '300px' : '500px'}
              height='fit-content'
              layout={{grow: 1}}>
          <Column width={'100%'} height={'100%'}>
            <Row margin={'10px 0 0'}>
              <DescriptiveText>
                By using the application you agree to CircleBlack’s Terms and Conditions and Privacy Policy.
              </DescriptiveText>
            </Row>
            <form onSubmit={e => {
              e.preventDefault();
              e.stopPropagation();
              setProcessing(true);

              return axiosInstance.put('/user/terms', {version: accepted})
                .then(() => {
                  history.push('/');
                })
                .catch(err => openModal({type: 'Error', title: 'AN ISSUE OCCURRED', err: err}))
                .finally(()=> setProcessing(false));
            }}>
              <Row wrap={true} margin={'10px 0 20px'}>
                <Button
                  width={'190px'}
                  importance={'secondary'}
                  size={'md'}
                  label={'Privacy Policy'}
                  disabled={false}
                  action={()=>openModal({
                    type: 'Disclosures',
                    defaultTab: 'privacyPolicy',
                  })}>
                </Button>
                <Button
                  width={'190px'}
                  importance={'secondary'}
                  size={'md'}
                  label={'Terms & Conditions'}
                  disabled={false}
                  action={()=>openModal({
                    type: 'Disclosures',
                    defaultTab: 'termsConditions',
                  })}>
                </Button>
              </Row>
              <Row margin={'10px 0'}>
                <Checkbox
                  title={'I have read and agree to the above terms.'}
                  width={'fit-content'}
                  onChange={(name, value) => setAccepted(!!value)}
                  dataPoint={{name: 'version', value: accepted}}
                />
              </Row>
              <Row margin={'10px 0 20px'}>
                <Button
                  processing={processing}
                  size={'md'}
                  width={'150px'}
                  importance={'primary'}
                  label={'Submit'}
                  action={'SUBMIT'}/>
              </Row>
            </form>
          </Column>
        </Tile>
      </Row>
    </Row>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
  product: state.product,
});
const mapDispatchToProps = (dispatch) => ({
  openModal: currentModal => dispatch(_openModal(currentModal)),
  removeModal: currentModal => dispatch(_removeModal(currentModal)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgreeToTerms));

AgreeToTerms.propTypes = {
  /**
   * User session
   */
  session: PropTypes.object.isRequired,
  /**
   * Function that opens modals throughout page
   */
  openModal: PropTypes.func.isRequired,
  /**
   * The Product
   */
  product: PropTypes.shape({
    brand: PropTypes.object.isRequired,
    version: PropTypes.string,
  }).isRequired,
  theme: PropTypes.object,
};
